import { type KeywordFlaggingDataSource } from '../../data/keyword-flagging.datasource'

export class DeleteKeywordListInteractor {
  constructor(private readonly dataSource: KeywordFlaggingDataSource) {}

  async execute(id: string): Promise<void> {
    await this.dataSource.deleteById(id)
  }
}
